module.exports = __webpack_public_path__ + "img/qhytn08zi4whfngmmxpm.63edf60f.jpg";